
import { Link } from "react-router-dom";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuSeparator,
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { UserAvatar } from "./UserAvatar";

interface UserDropdownMenuProps {
  username: string;
  isAdmin: boolean;
  userCredits: number;
  onLogout: () => void;
}

export function UserDropdownMenu({ username, isAdmin, userCredits, onLogout }: UserDropdownMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <UserAvatar username={username} isAdmin={isAdmin} userCredits={userCredits} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem className="font-semibold">
          {username}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem>Προφίλ</DropdownMenuItem>
        {!isAdmin && (
          <DropdownMenuItem className="flex justify-between">
            <span>Credits:</span> 
            <span className="font-bold text-primary">{userCredits}</span>
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <>
            <DropdownMenuItem>
              <Link to="/admin" className="w-full">Περιβάλλον Διαχείρισης</Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem onClick={onLogout}>
          Αποσύνδεση
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
